<div class="raptor-page-container" [ngClass]="{ 'loading': raptorStepService.submitted }" [formGroup]="form">
  <div style="display:none" [innerHTML]="stylesheet"></div>
  <open-raptor-progress *ngIf="!(formData.settings && formData.settings.hide_progress_bar)" [progress]="formData.progress" [pages]="formData.total_pages"></open-raptor-progress>
  <open-raptor-banner-header *ngIf="formData.settings?.banners" [data]="formData.settings?.banners"></open-raptor-banner-header>
  <open-raptor-banner-header *ngIf="bannerHeaders" [data]="bannerHeaders"></open-raptor-banner-header>
  <div class="grid">
    <div class="cell margin-vertical-xsmall margin-right-medium margin-left-xmedium progress-nav">
      <button mat-icon-button color="primary" type="button" (click)="raptorFormService.reset()"><mat-icon>west</mat-icon></button>
    </div>
  </div>

  <div class="raptor-page-content">
    <div class="raptor-page-panel" [class]="raptorStepService.action" *ngIf="raptorStepService.stepReady">

      <div class="grid">
        <div class="raptor-page-main-panel cell cell-small-col-span-6 cell-large-col-span-12">
          <header class="margin-bottom-xmedium padding-horizontal-medium">
            <h1 class="text-center" [ngClass]="{'margin-bottom-medium': formData.subtext}" *ngIf="formData.heading">{{ formData.heading }}</h1>
            <p class="text-center margin-bottom-none" *ngIf="formData.subtext">
              <mat-icon>pin_drop</mat-icon>
              {{ formData.subtext }}
            </p>
          </header>

          <div *ngIf="covers.length > 1" class="carousel-controls show-for-medium-down text-center" [class]="'coverLength-' + covers.length">
            <ul>
              <li *ngFor="let cover of covers; let i = index">
                <a (click)="scrollCovers(i)" [ngClass]="{'active': panelPosition === i}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                    <circle cx="7.21777" cy="7" r="7" fill="black"/>
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          <div *ngIf="covers.length > 1" class="carousel-controls show-for-medium-down text-center" [class]="'coverLength-' + covers.length">
            <a class="previous" *ngIf="panelPosition > 0" (click)="navigateCovers('previous')"><mat-icon class="chevron_left"></mat-icon></a>
            <a class="next" *ngIf="panelPosition < covers.length - 1" (click)="navigateCovers('next')"><mat-icon class="chevron_right"></mat-icon></a>
          </div>

          <!-- MAIN CONTENT -->
          <div class="raptor-page-price-container grid" [class]="'coverLength-' + covers.length">
            <div *ngFor="let cover of covers; let i = index"
              [class]="'raptor-page-price-panel cell cell-large-col-span-4 raptor-page-price-panel-length-' + covers.length"
              [ngClass]="{
                'has-extra-help': cover.is_featured && cover.extras.flight_delay,
                'cell-large-col-span-6 cell-large-col-start-4 cell-medium-col-span-4 cell-medium-col-start-2 cell-small-col-span-4 cell-small-col-start-2 cell-tiny-col-span-4 cell-tiny-col-start-1': covers.length === 1,
                'cell-medium-col-span-4': covers.length && covers.length === 2 || covers.length && covers.length === 4,
                'cell-small-col-span-6': covers.length > 1
              }"
            >
              <div class="raptor-page-price-container-extras" *ngIf="hasFeaturedCovers(covers)">
                <div class="raptor-page-extras-panel" *ngIf="hasFeatured(cover)" [ngClass]="{'active': cover.cover.product_slug === formData.data.product_slug && cover.cover.cover_type === formData.data.cover_type && cover.cover.cover_level === formData.data.cover_level}">
                  <div class="extra-badge" *ngIf="hasFeatureHighlight(cover)">
                    <div *ngFor="let feature of getCoverFeatures(cover)">
                      <open-tooltip *ngIf="feature.feature_highlight"
                        [tooltipContent]="feature.feature_details.tooltip"
                        tooltipType="both"
                        [tooltipLabel]="feature.feature_details.label" 
                      >
                      </open-tooltip>
                    </div>
                  </div>
                  <div *ngIf="cover.extras.flight_delay && !hasFeatureHighlight(cover)">
                    <mat-icon class="raptor-page-price-selected-icon" *ngIf="cover.cover.product_slug === formData.data.product_slug && cover.cover.cover_type === formData.data.cover_type && cover.cover.cover_level === formData.data.cover_level">check_circle</mat-icon>
                    <div class="extra-badge" *ngIf="cover.extras.flight_delay">
                      <open-tooltip
                        [tooltipContent]="getCoverInfo(cover, 'extra_help').text"
                        tooltipType="both"
                        tooltipLabel="Smart flight delay included"
                      >
                      </open-tooltip>
                    </div>
                  </div>
                </div>
              </div>

              <div class="raptor-page-price-content flex flex-column" [ngClass]="{'featured': cover.is_featured, 'no-extras': cover.is_featured && (!cover.extras.flight_delay && !hasFeatureHighlight(cover)), 'active': cover.cover.product_slug === formData.data.product_slug && cover.cover.cover_type === formData.data.cover_type && cover.cover.cover_level === formData.data.cover_level}">
                <div class="raptor-page-price-highlight">
                  <div class="raptor-page-price-highlight-panel">
                    <mat-icon class="raptor-page-price-selected-icon" *ngIf="cover.cover.product_slug === formData.data.product_slug && cover.cover.cover_type === formData.data.cover_type && cover.cover.cover_level === formData.data.cover_level && !cover.is_featured">check_circle</mat-icon>
                    <h2 class="raptor-page-price-cover-name text-center">{{ cover.label }}</h2>
                    <div class="text-small flex-grow" *ngIf="getCoverInfo(cover, 'description')">{{ getCoverInfo(cover, 'description') }}</div>

                    <div *ngIf="cover.banner" class="raptor-page-price-banner-box padding-top-xsmall">
                      <div *ngFor="let banner of cover.banner">
                        <div *ngIf="banner.tag" class="margin-bottom-xsmall raptor-page-price-banner">
                          {{ getTagLabel(banner) }}
                        </div>
                      </div>
                    </div>

                    <div class="text-left width-full">
                      <div class="raptor-page-price-discount text-center margin-bottom-xxsmall" *ngIf="getCoverDiscount(cover)">WAS 
                        <open-price [price]="getCoverDiscount(cover)" [precision]="2" size="small"></open-price>
                      </div>
                      <div class="text-center margin-bottom-xxsmall">
                        <open-price *ngIf="!raptorStepService.updating" [price]="getCoverPrice(cover)" [precision]="2" class="margin-bottom-small font-700" size="large"></open-price>
                        <div *ngIf="raptorStepService.updating" class="padding-top-small margin-bottom-small">
                          <mat-spinner diameter="50" class="price-spinner"></mat-spinner>
                        </div>
                      </div>
                      <div class="text-center text-xsmall" *ngIf="cover.has_additional_charges && cover.additionalChargesBanners" [ngClass]="{ 'featured': cover.is_featured }" [innerHTML]="cover.additionalChargesBanners.tag.annual"></div>

                      <div class="text-center text-xsmall" *ngIf="!cover.has_additional_charges">{{ getCoversGstCopy() }}</div>
                    </div>

                    <div class="page-price-select-cover width-full">
                      <button mat-flat-button color="primary" type="button" class="width-full" (click)="selectCover(cover)" [disabled]="raptorStepService.loading">
                        <span class="mdc-button__label" *ngIf="!raptorStepService.loading">{{ getCoverInfo(cover, 'submit_label') || 'Select' }}</span>
                        <mat-spinner *ngIf="raptorStepService.loading" diameter="28"></mat-spinner>
                      </button>
                    </div>
                  </div>

                  <div class="raptor-page-price-features text-left">
                    <span class="text-center loud-small">{{getCoverInfo(cover, 'features_heading')}}</span>
                    <ul>
                      <li *ngFor="let feature of getCoverFeatures(cover)" class="raptor-page-price-feature">
                        <div class="flex">
                          <div class="flex-shrink">
                            <mat-icon [ngClass]="feature.is_optional_feature ? 'optional' : ''">
                              {{ feature.is_optional_feature ? 'cancel' : 'check_circle_fill' }}
                            </mat-icon>
                          </div>
                          <span class="text-xsmall" [innerHTML]="feature.text"></span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="raptor-page-price-lowlight">
                  <div class="raptor-page-cover-features">
                    <div>
                      <mat-accordion *ngFor="let feature of getCoverInfo(cover, 'features'); index as featureIndex;">
                        <mat-expansion-panel [expanded]="panelOpen[i][featureIndex]" (opened)="accordionOpend(featureIndex)" (closed)="accordionClosed(featureIndex)">
                          <mat-expansion-panel-header>
                            <mat-panel-title><strong>{{ feature.heading }}</strong></mat-panel-title>
                          </mat-expansion-panel-header>
                          <div *ngFor="let item of feature.items" class="flex margin-bottom-xsmall" [class]="item.class">
                            <div class="flex-grow" [innerHTML]="item.text"></div>
                            <strong class="padding-left-xxsmall flex-shrink text-right text-nowrap" [innerHTML]="item.type"></strong>
                          </div>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </div>
                  </div>
                </div>

                <div class="raptor-page-price-pds padding-top-none">
                  <div class="width-full flex flex-column">
                    <a *ngFor="let footerLink of getCoverInfo(cover, 'footer_links')" [href]="footerLink.link" mat-button target="_blank">{{footerLink.label}}</a>

                    <open-tooltip
                      *ngIf="getCoverInfo(cover, 'covered_help')"
                      [tooltipContent]="getCoverInfo(cover, 'covered_help').text"
                      [tooltipType]="'link'"
                      [tooltipLabel]="'Compare plans'"
                      [classes]="'axis-travel-compare-prices-cover-tooltip'"
                    ></open-tooltip>
                  </div>
                </div>
                
              </div>
            </div>
          </div>

          <div class="grid grid-wrapper margin-vertical-xxsmall" *ngIf="formData.cover_exclusions_info && formData.cover_exclusions_info.length">
            <div class="cell cell-large-col-span-10 cell-medium-col-span-6 cell-small-col-span-6 cell-large-col-start-2 cell-medium-col-start-2">
              <div class="open-form-info radius-ai padding-medium">
                <div *ngFor="let info of formData.cover_exclusions_info">
                  <b *ngIf="info.heading" class="margin-bottom-xsmall">{{ info.heading }}</b>
                  <p *ngIf="info.content">{{ info.content }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="raptor-page-column-container raptor-page-price-section grid">
        <div
          class="raptor-page-column-content cell cell-small-col-span-6"
          [ngClass]="{
            'bg-block radius-block': formData.settings.card === true,
            'cell-large-col-span-12': formData.settings.size !== 'small' && formData.settings.size !== 'medium',
            'cell-large-col-span-8 cell-medium-col-span-6': formData.settings.size === 'medium',
            'cell-large-col-start-3 cell-medium-col-start-2': formData.settings.size === 'medium' && (!formData.settings.align || formData.settings.align === 'center'),
            'cell-large-col-start-5 cell-medium-col-start-3': formData.settings.size === 'medium' && formData.settings.align === 'right',
            'cell-large-col-span-6 cell-medium-col-span-4': formData.settings.size === 'small',
            'cell-large-col-start-4 cell-medium-col-start-3': formData.settings.size === 'small' && (!formData.settings.align || formData.settings.align === 'center'),
            'cell-large-col-start-1': formData.settings.size === 'small' && formData.settings.align === 'left',
            'cell-large-col-start-7 cell-medium-col-start-5': formData.settings.size === 'small' && formData.settings.align === 'right'
          }"
        >
          <div *ngFor="let section of formData.sections; index as i" class="form-row">
            <open-raptor-section *ngIf="i > 0" [section]="section" [form]="form"></open-raptor-section>
          </div>
        </div>
      </div>
    </div>
    <input type="hidden" formControlName="cover_level" id="cover_level" />
    <input type="hidden" formControlName="cover_type" id="cover_type" />
    <input type="hidden" formControlName="product_slug" id="product_slug" />
    <button type="submit" hidden id="coverSubmit">submit</button>
  </div>

  <div class="raptor-prices-marketing raptor-page-panel" [class]="raptorStepService.action" *ngIf="raptorStepService.stepReady && formData.settings && formData.settings.marketing && marketingInfo">
    <div class="grid padding-horizontal-medium padding-top-xlarge" #marketing>
      <div class="cell cell-small-col-span-6 cell-large-col-span-12">
        <p class="margin-bottom-small text-center" *ngIf="marketingInfo.sub_text" [innerHTML]="marketingInfo.sub_text"></p>
        <h2 class="margin-bottom-small margin-top-xbig text-center" *ngIf="marketingInfo.heading">{{ marketingInfo.heading }}</h2>

        <div class="marketing-info-content margin-top-medium padding-medium padding-bottom-none" *ngIf="marketingInfo.content && marketingInfo.content.length">
          <div *ngFor="let item of marketingInfo.content" class="padding-bottom-medium">
            <div class="flex">
              <div class="flex-shrink margin-right-medium">
                <open-svg-icon [name]="item.icon" class="small"></open-svg-icon>
              </div>
              <div>
                <h3 class="margin-bottom-xsmall">{{ item.text }}</h3>
                <div class="text-small" [innerHTML]="item.sub_text"></div>
              </div>
            </div>

            <div *ngFor="let tooltip of item.tooltips">
              <open-tooltip
                [tooltipContent]="tooltip.value"
                [tooltipType]="'link'"
                [tooltipLabel]="tooltip.key"
                [classes]="tooltip.key"
              ></open-tooltip>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <div class="marketing-info-footer" *ngIf="marketingInfo.footer">
      <div class="grid padding-horizontal-medium">
        <div class="cell cell-small-col-span-6 cell-large-col-span-12">
          <p class="margin-none text-xsmall" [innerHTML]="marketingInfo.footer"></p>
        </div>
      </div>
    </div>
  </div>

  <div class="raptor-prices-disclaimer" *ngIf="disclaimers && !raptorStepService.loading">
    <div class="grid grid-wrapper mat-typography">
      <div class="raptor-prices-disclaimer-content cell cell-small-col-span-6 cell-large-col-span-12">
        <div *ngFor="let disclaimer of disclaimers; index as i">
          <div *ngIf="disclaimer.type === 'promotional'" class="raptor-page-price-banner-disclaimer text-xsmall" [ngClass]="{'margin-bottom-xsmall':i > 1}">
            {{ disclaimer.content }}
          </div>
          <!-- Showing extras banners below to list content -->
          <div *ngIf="disclaimer.type === 'additionalCharges'" class="raptor-page-price-banner-disclaimer text-xsmall" [ngClass]="{'margin-bottom-xsmall':i > 1}">
            {{ disclaimer.content }}
          </div>
          <div *ngIf="disclaimer.type === 'banner'" class="raptor-page-banner text-xsmall" [ngClass]="{'margin-bottom-xsmall':i > 1}" [innerHTML]="disclaimer.content">
          </div>
        </div>
        <ul *ngIf="includedExtrasDisclaimers?.length">
          <li class="raptor-page-price-banner-disclaimer text-xsmall" *ngFor="let extrasDisclaimer of includedExtrasDisclaimers"><strong>{{ extrasDisclaimer.label }}:</strong> {{ extrasDisclaimer.disclaimer }}</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="raptor-prices-disclaimer" *ngIf="formData.disclaimer && formData.disclaimer.content">
    <div class="grid grid-wrapper" *ngIf="!raptorStepService.loading" ngClass="{'padding-top-big': !disclaimers || !disclaimers.length}">
      <div class="cell cell-small-col-span-6 cell-large-col-span-12">
        <p class="raptor-page-price-banner-disclaimer text-xsmall" [innerHTML]="formData.disclaimer.content"></p>
      </div>
    </div>
  </div>
</div>
